
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'MailingExpired',
})
export default class MailingExpired extends Vue {}
